<div class="spinner">
    <div class="spinner__body">
        <nx-spinner size="large" negative="true"></nx-spinner>
    </div>
</div>